import * as types from '../constants'
import _ from 'lodash'
const initState = {
    conversations: [],
    conversationsInf: {},
    conversationsMessages: {},
    activeConversation: null,
    tempChat: null
}

let timeout = setTimeout(()=>{}, 10);

export default function(state = initState, action) {
    switch (action.type) {
        case types.SET_ACTIVE_CONVERSATION:
          state.activeConversation = action.payload
        return _.cloneDeep(state)
        case types.TYPING:
        if (state.conversationsInf[action.payload.conversation]) {
          state.conversationsInf[action.payload.conversation].isTyping = true
        } else {
          state.conversationsInf[action.payload.conversation] = {
            isTyping: true
          }
        }
        return _.cloneDeep(state)
        case types.CLEAR_TYPING:
        if (state.conversationsInf[action.payload.conversation]) {
          state.conversationsInf[action.payload.conversation].isTyping = false
        } else {
          state.conversationsInf[action.payload.conversation] = {
            isTyping: false
          }
        }
        return _.cloneDeep(state)
        case types.GET_CHAT_HISTORY:
            action.payload.forEach((item, i) => {
              if (!state.conversations.includes(item._id)) state.conversations.push(item._id)
              state.conversationsInf[item._id] = item
            });
            return _.cloneDeep(state)
        case types.GET_CHAT_INF:

            if (!state.conversations.includes(action.payload._id)) {
              state.conversations.push(action.payload._id)
            }
            state.conversationsInf[action.payload._id] = action.payload
            return _.cloneDeep(state)
        case types.GET_MESSAGE:
            let messObj = {}
            action.payload.messages.forEach((mess, i) => {
              messObj[mess._id] = mess
            });

            if (state.conversationsMessages[action.payload.conversation]) {
              Object.keys(messObj).forEach((key, i) => {
                state.conversationsMessages[action.payload.conversation][key] = messObj[key]
              });

            } else {
              state.conversationsMessages[action.payload.conversation] = messObj
            }
            return _.cloneDeep(state)
        case types.GET_CHAT_BY_USER:
            if (!state.conversations.includes(action.payload.conversation._id)) {
              state.conversations.push(action.payload.conversation._id)
            }
            state.conversationsInf[action.payload.conversation._id] = action.payload.conversation

            let messagesObj = {}
            action.payload.messages.forEach((mess, i) => {
              messagesObj[mess._id] = mess
            });

            if (state.conversationsMessages[action.payload.conversation._id]) {
              Object.keys(messagesObj).forEach((key, i) => {
                state.conversationsMessages[action.payload.conversation._id][key] = messagesObj[key]
              });

            } else {
              state.conversationsMessages[action.payload.conversation._id] = messagesObj
            }
            state.activeConversation = action.payload.conversation._id
        return _.cloneDeep(state)
        case types.SET_TEMP_CHAT:
            state.tempChat = action.payload
        return _.cloneDeep(state)

        default:
            return state;
    }
}
